import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AuthService, RatingReviewService } from "../../services";
import { Modal, Button } from "react-bootstrap";
import { routes } from "../../constants/routes";
import { toast } from "react-toastify";
import {
  addDefaultImg,
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../utils/common-methods";
import ImagePreview from "../../components/Image/ImagePreview";
import { TraderUnitService } from "../../services";

const TraderShopFront = (props) => {
  const { unitId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let loginUser = AuthService.getLoginUser();

  const [showUnitDocumentModal, setUnitDocumentShow] = useState(false);
  const [showUnitShopModal, setUnitShopShow] = useState(false);

  const [imageList, setImageList] = useState([]);
  const [units, setUnits] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [unitShopFronts, setUnitShopFronts] = useState([]);


useEffect(() => {
  const fetchData = async () => {  
      await getData();   
  };
  fetchData();
}, []);

  const getData = async () => {
    try {
      if (unitId && unitId.length > 5) {
        props.application.setLoading(true);
        const res = await RatingReviewService.getBusinessProfileById(unitId);
        if (res?.isSuccess && res?.data) {
          setImageList(res?.data?.images);
          await getUnits(unitId);
        }
        props.application.setLoading(false);
      } else {
        navigate(routes.ERROR);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getUnits = async (userId) => {
    try {
      var res = await TraderUnitService.getActiveUnitListByTraderId(userId);
      if (res?.isSuccess) {
        setUnits(res?.data || []);
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handlePreview = (document) => {
    window.open(document, "_blank"); // Open PDF in new tab
  };
  const getUnitDocuments = async (unitId) => {
    try {
      const res = await TraderUnitService.getActiveDocumentsByUnitId(unitId);
      if (res?.isSuccess) {
        setDocumentsList(res?.data || []);
        setUnitDocumentShow(true);
      }
      //  else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getUnitShopFront = async (unitId) => {
    try {
      const res = await TraderUnitService.getActiveShopFrontsByUnitId(unitId);
      if (res?.isSuccess) {
        setUnitShopFronts(res?.data || []);
        setUnitShopShow(true);
      }
      //  else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleUnitShopClose = () => {
    // setUnitShopFronts([]);
    setUnitShopShow(false);
  };
  const handleUnitDocumentClose = () => {
    // setDocumentsList([]);
    setUnitDocumentShow(false);
  };
  const formatNull = (add) => {
    return add ? add + "," : "";
  };
  const formatNullWithOutComma = (add) => {
    return add ? add : "";
  };

  const handleBack = () => {
    navigate(routes.ADMIN_EDIT_TRADER, {
      state: { profile: location?.state?.profile },
    });
  };

  return (
    <React.Fragment>
      <section
        className="review-points"
        style={{ paddingTop: "0px !important" }}
      >
        <div className="poitns3">
          <div className="row">
            <div className="col-lg-6 col-sm-6">
              <h2 className="review-title">Shop Front Details</h2>
              <span className="review-subtitle">
                <strong>{location?.state?.profile?.businessName}</strong>
                {" ("}
                {location?.state?.profile?.email}
                {")"}
              </span>
            </div>
            <div className="col-lg-6 col-sm-6 d-flex justify-content-lg-end justify-content-sm-start">
              <div className="verifier-buttton">
                <Button variant="info" onClick={handleBack}>
                  Back
                </Button>{" "}
              </div>
            </div>
          </div>

          <div
            className="pictures-review"
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              backgroundColor: "#fff",
              padding: "20px",
            }}
          >
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  id="simple-tab-1"
                  data-bs-toggle="tab"
                  href="#simple-tabpanel-1"
                  role="tab"
                  aria-controls="simple-tabpanel-1"
                  aria-selected="true"
                >
                  <strong> Units</strong>
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="simple-tab-0"
                  data-bs-toggle="tab"
                  href="#simple-tabpanel-0"
                  role="tab"
                  aria-controls="simple-tabpanel-0"
                  aria-selected="false"
                >
                  <strong>Pictures</strong>
                </a>
              </li>
            </ul>
            <div className="tab-content " id="tab-content">
              <div
                className="tab-pane active"
                id="simple-tabpanel-1"
                role="tabpanel"
                aria-labelledby="simple-tab-1"
              >
                {units.map((unit, index) => (
                  <div key={index} className="row pt-2 pb-2 mb-3">
                    <h2 className="unit-name">{unit?.unitName}</h2>
                    <div className="col-md-3">
                      <img
                        src={unit?.imageUrl}
                        alt=""
                        onError={addDefaultImg}
                      />
                    </div>
                    <div className="col-md-7">
                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Business Type : </div>
                        <div className="sec-col">{unit?.businessType} </div>
                      </div>
                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">
                          Date of Establishment :{" "}
                        </div>
                        <div className="sec-col">
                          {formatDateENGB(
                            unit?.establishmentDate?.split("T")[0]
                          )}
                        </div>
                      </div>

                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Address : </div>
                        <div className="sec-col">
                          {formatNull(unit?.street) +
                            formatNull(unit?.city) +
                            formatNull(unit?.stateName) +
                            formatNull(unit?.countryName) +
                            formatNullWithOutComma(unit?.zipCode)}
                        </div>
                      </div>

                      {loginUser && (
                        <div className="d-flex flex-sm-column flex-md-row flex-column">
                          <div className="first-col">Contact Number : </div>
                          <div className="sec-col">{unit?.contactNumber}</div>
                        </div>
                      )}

                      {loginUser && (
                        <div className="d-flex flex-sm-column flex-md-row flex-column">
                          <div className="first-col">Email ID : </div>
                          <div className="sec-col">{unit?.email}</div>
                        </div>
                      )}

                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Contact Person : </div>
                        <div className="sec-col">{unit?.contactPerson}</div>
                      </div>
                    </div>
                    <div className="col-md-2 d-flex justify-content-md-end justify-content-sm-start">
                      <div className="d-flex flex-sm-row flex-md-column gp mt-2 mt-sm-2">
                        <div
                          style={{ cursor: "pointer" }}
                          className="icon-outer"
                          onClick={(e) => {
                            e.preventDefault();
                            getUnitDocuments(unit?.id);
                          }}
                        >
                          <img src="/assets/images/icon-doc.jpg" alt="" />
                          View Documents
                        </div>

                        <div
                          style={{ cursor: "pointer" }}
                          className="icon-outer"
                          onClick={(e) => {
                            e.preventDefault();
                            getUnitShopFront(unit?.id);
                          }}
                        >
                          <img src="/assets/images/icon-shop.jpg" alt="" />
                          View Shopfront
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {units?.length === 0 && (
                  <div
                    className="col-lg-3 col-md-6 col-sm-12"
                    style={{ minHeight: "100px" }}
                  >
                    {" "}
                    No shop front
                  </div>
                )}
                {/* {units?.length === 0 && (
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    {" "}
                    No Shop front
                  </div>
                )} */}
              </div>
              <div
                className="tab-pane "
                id="simple-tabpanel-0"
                role="tabpanel"
                aria-labelledby="simple-tab-0"
              >
                <div className="row">
                  {imageList.map((image, index) => (
                    <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                      <img
                        style={{ width: "319px", height: "194px" }}
                        src={image?.imageUrls}
                        alt=""
                        onError={addDefaultImg}
                      />
                    </div>
                  ))}
                  {imageList?.length === 0 && (
                    <div                   
                      className="col-lg-3 col-md-6 col-sm-12"
                      style={{ minHeight: "100px" }}
                    >
                      {" "}
                      No pictures available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={showUnitDocumentModal}
        onHide={handleUnitDocumentClose}
        backdrop="static"
        centered
        dialogClassName="custom-modal modal-xl"
      >
        <Modal.Header closeButton className="modal-main-header"></Modal.Header>
        <Modal.Body>
          <div className="col-lg-12 col-sm-12">
            <div style={{ textAlign: "center" }}>
              {" "}
              <div className="logo-img">
                <img src="/assets/images/logo-swallow.jpg" alt="" />
              </div>
              <br />
              <h4 className="modal-title">Upload Document</h4>
              <br />
            </div>
          </div>
          <div className="col-lg-12 col-sm-12">
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Document Type</th>
                    <th>Title</th>
                    <th>Expiry Date</th>
                    {/* <th>Name</th>
            <th>Email</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documentsList.map((document, idx) => (
                    <tr key={idx}>
                      <td>{document?.documentsTypeName}</td>
                      <td>
                        {document?.documentName ? document?.documentName : "-"}
                      </td>
                      <td>
                        {document?.expiryDate
                          ? formatDateENGB(document?.expiryDate?.split("T")[0])
                          : "N/A"}
                      </td>
                      {/* <td>{businessData.contactlegalname}</td>
              <td>{businessData.email}</td> */}
                      {document?.documentFileURL && (
                        <td>
                          <span
                            onClick={() =>
                              handlePreview(document?.documentFileURL)
                            }
                            style={{
                              cursor: "pointer",
                              marginRight: "10px",
                              color: "#007bff",
                            }}
                          >
                            <i className="ri-eye-fill"></i> Preview
                          </span>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showUnitShopModal}
        onHide={handleUnitShopClose}
        backdrop="static"
        centered
        dialogClassName="custom-modal modal-xl"
      >
        <Modal.Header closeButton className="modal-main-header">
          {/* <Modal.Title className="modal-title-centered">
            <div className="login-img11">
              <img src="/assets/images/logo-swallow.jpg" alt="" />
            </div>
            <br />
            Unit Shopfronts
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12 col-sm-12">
            <div style={{ textAlign: "center" }}>
              {" "}
              <div className="logo-img">
                <img src="/assets/images/logo-swallow.jpg" alt="" />
              </div>
              <br />
              <h4 className="modal-title">Unit Shopfronts</h4>
              <br />
            </div>
          </div>
          <div className="col-lg-12 col-sm-12">
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Product Image</th>
                    <th>Product Title</th>
                    <th>Product Description</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {unitShopFronts.map((shop, idx) => (
                    <tr key={idx}>
                      <td>
                        <ImagePreview
                          src={shop?.imageUrl || routes.DEFAULT_IMAGE}
                          width="100px"
                          height="100px"
                          style={{
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            border: "2px solid darkgreen", // Corrected `BorderAll` typo
                          }}
                        ></ImagePreview>
                      </td>
                      <td>{shop?.productTitle ? shop?.productTitle : "-"}</td>
                      <td>
                        {shop?.productDescription
                          ? shop?.productDescription
                          : "-"}
                      </td>
                      <td>
                        {shop?.price ? "£" + formatAmount(shop?.price) : "£0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TraderShopFront);
